(function () {
    var form = document.querySelector('#insights-article-form');
    if(form) {
        var submitButton = form.querySelector('button[type="submit"]');
        var formInputs = form.querySelectorAll('input');
        var dropDownmenus = form.querySelectorAll('select');
        var termsAndConditionsCheckbox = form.querySelector('input[name="i_have_read_and_agree"]');

        formInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                if (form.checkValidity() && dropDownmenus[0].value !== 'Select Job Title' && dropDownmenus[1].value !== 'Select Country' && termsAndConditionsCheckbox.checked) {
                    submitButton.removeAttribute('disabled');
                    submitButton.classList.remove('bg-neutral-200', 'text-neutral-500', 'hover:cursor-not-allowed');
                    submitButton.classList.add('bg-neutral-800', 'text-white');
                } else {
                    submitButton.setAttribute('disabled', 'true');
                    submitButton.classList.remove('bg-neutral-800', 'text-white');
                    submitButton.classList.add('bg-neutral-200', 'text-neutral-500', 'hover:cursor-not-allowed');
                }
            });
        });

        dropDownmenus.forEach(function (select) {
            select.addEventListener('change', function () {
                if (form.checkValidity() && dropDownmenus[0].value !== 'Select Job Title' && dropDownmenus[1].value !== 'Select Country' && termsAndConditionsCheckbox.checked) {
                    submitButton.removeAttribute('disabled');
                    submitButton.classList.remove('bg-neutral-200', 'text-neutral-500', 'hover:cursor-not-allowed');
                    submitButton.classList.add('bg-neutral-800', 'text-white');
                } else {
                    submitButton.setAttribute('disabled', 'true');
                    submitButton.classList.remove('bg-neutral-800', 'text-white');
                    submitButton.classList.add('bg-neutral-200', 'text-neutral-500', 'hover:cursor-not-allowed');
                }
            });
        });

    }
})();
